import { createFileRoute } from '@tanstack/react-router';
import { ArtifactDetailPage } from '@/pages/organization/artifacts/ArtifactDetailPage';
import { createEntityBreadcrumbLoader } from '@/lib/entity-breadcrumb';

export const Route = createFileRoute('/$slug/organization/artifacts/$artifactId')({
  loader: createEntityBreadcrumbLoader('artifact', 'artifactId'),
  component: RouteComponent
});

function RouteComponent() {
  const { artifactId } = Route.useParams();
  return <ArtifactDetailPage artifactId={artifactId} />;
}
